/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { styled, useFlux } from 'fierry/react.old';

import BorderCenter from 'galax/react/map/hex/border.center';


const getAggressiveInteractions = (zone) =>
{
  let collection = [];

  for (const interaction of zone.getInteractionsTo())
  {
    if ((interaction.isAggressive()) && interaction.getUserID() !== zone.getUserID())
    {
      collection.push(interaction);
    }
  }

  for (const projectile of zone.getProjectilesTo())
  {
    if (projectile.getUserID() !== zone.getUserID())
    {
      collection.push(projectile);
    }
  }

  return collection;
}


const Circle = styled.circle`
  fill: var(--svg-always-other);
`;


// TODO Radius should increase with zoom level?
const getDotProps = ({ geometry, zone, offset }) =>
{
  const size = geometry.getHex().getExternalWidth() / 2;

  return { cx: -3/4 * size, cy: 0.375 * size, r: 1 };
}


const Indicator = ({ geometry, zone, offset, ...props }) =>
{
  const width = geometry.getHex().getExternalWidth();

  const cx = 0.125 * width;
  const cy = 0.375 * width / 2 - offset;

  return <Circle {...props} cx = {cx} cy = {cy} r = {1} />;
}


const Component = ({ interactions, ...props }) =>
{
  let children = [];

  const maxOffset = props.geometry.getHex().getExternalWidth() * 0.375;
  const stepOffset = maxOffset / 3;

  let offset = 0;

  for (const interaction of interactions)
  {
    children.push(<Indicator key = {offset} {...props} offset = {offset} />);

    if (offset >= maxOffset)
    {
      break;
    }

    offset += stepOffset;
  }

  return children;
}


export default (props) =>
{
  const { zone, geometry, isTarget } = props;

  if (isTarget || !geometry.getHex().isEntityVisible())
  {
    return null;
  }

  const interactions = getAggressiveInteractions(zone);

  return interactions.length ? <BorderCenter {...props} Component = {Component} interactions = {interactions} index = {1} /> : null;
}
